import { getDay } from 'date-fns';
import { RequestNewVersion } from '../../../../classes/RequestNewVersion';
import moment from 'moment';
import { forEach } from 'lodash';

export const isWeekday = (date) => {
  const day = getDay(date);
  return day !== 0 && day !== 6;
};

export const holidayDates = async () => {
  const request = new RequestNewVersion(
    `${process.env.REACT_APP_URL_API_LARAVEL}/me/holidays`,
    'get',
    null,
    {}
  );

  const holidaysListResponse = await request.executeRequest();
  if (
    typeof holidaysListResponse === 'object' &&
    Number(holidaysListResponse.code) === 200 &&
    typeof holidaysListResponse.response === 'object' &&
    Array.isArray(holidaysListResponse.response.holidays)
  ) {
    const holidayDates = [];
    forEach(holidaysListResponse.response.holidays, (holiday) => {
      holiday = moment(holiday).toDate();
      holidayDates.push(holiday);
    });
    return holidayDates;
  }
};
